import Radio from '@material-ui/core/Radio';
import createSelectionComponent from "./createSelectionComponent"

export default createSelectionComponent(Radio, {
  isChecked: (v, { checkedValue }) => v === checkedValue,
})



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/Radio.js